import MutateExhibit from "./MutateExhibit";

export default MutateExhibit